import { MtUser } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import { UserFilters } from "client/store"
import * as types from "./types"


export const setProjectUserList = (projectUserList: types.ProjectUserList) => ({
    type: inferLiteral(types.PROJECT_USER_LIST),
    projectUserList,
})
export const setAssignedProjectUserIds = (userIds: readonly number[]) => ({
    type: inferLiteral(types.ASSIGNED_PROJECT_USER_IDS),
    userIds,
})
export const setAssignedProjectUserSort = (sortColumn: keyof MtUser, sortOrder: OrderType) => ({
    type: inferLiteral(types.ASSIGNED_PROJECT_USER_SORT),
    sortColumn,
    sortOrder,
})
export const setAssignedProjectUserFilters = (filters: UserFilters) => ({
    type: inferLiteral(types.ASSIGNED_PROJECT_USER_FILTERS),
    filters,
})
export const setNotAssignedProjectUserIds = (userIds: readonly number[]) => ({
    type: inferLiteral(types.NOT_ASSIGNED_PROJECT_USER_IDS),
    userIds,
})
export const setNotAssignedProjectUserSort = (sortColumn: keyof MtUser, sortOrder: OrderType) => ({
    type: inferLiteral(types.NOT_ASSIGNED_PROJECT_USER_SORT),
    sortColumn,
    sortOrder,
})
export const setNotAssignedProjectUserFilters = (filters: UserFilters) => ({
    type: inferLiteral(types.NOT_ASSIGNED_PROJECT_USER_FILTERS),
    filters,
})
export const setNotAssignedProjectUserSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.NOT_ASSIGNED_PROJECT_USER_SELECTED),
    selected,
})
export const setProjectUserReloadList = (value: boolean) => ({
    type: inferLiteral(types.PROJECT_USER_RELOAD_LIST),
    value,
})
